import { m } from '@sohanscript/i18n';
import { Link } from '@/components/link';

export function QuickLinks() {
	const links = [
		{ label: m.quick_link_os_ui(), href: '/os' },
		{
			label: m.quick_link_github_cms(),
			href: '/note/using-github-as-a-content-management-system',
		},
		{
			label: m.quick_link_20lab(),
			href: '/work/20lab',
		},
		{
			label: m.quick_link_react_native_setup(),
			href: '/note/the-lean-react-native-setup-no-android-studio-required',
		},
	];

	return (
		<ul className="space-y-2.5">
			{links.map((l) => (
				<li key={l.href}>
					<Link
						to={l.href as '/'}
						className="group inline-flex items-center gap-2 text-foreground/80 text-sm transition-colors hover:text-foreground"
					>
						<span className="text-primary/70 transition-colors group-hover:text-primary">
							→
						</span>
						<span className="relative">
							{l.label}
							<span className="absolute -bottom-0.5 left-0 h-px w-0 bg-foreground transition-colors duration-300 group-hover:w-full" />
						</span>
					</Link>
				</li>
			))}
		</ul>
	);
}
